<template>
  <div class="row text-left mt-4">
    <div v-if="grantApplication != null" class="col">
      <div class="text-center">
        <button class="btn btn-primary" v-on:click="downloadApplication">
          Download
        </button>
      </div>
      <h5 v-if="lettersOfInquiry.length > 0" class="mt-4">
        <strong>Letters of Inquiry</strong>
      </h5>
      <div
        v-if="lettersOfInquiry.length > 0"
        style="background-color:gray; height:1px; width:100%"
      />
      <div
        class="container"
        v-for="response in lettersOfInquiry"
        :key="response.Grant_Application_Response_Id"
      >
        <div class="container">
          <div class="row mt-2">
            <div class="col">
              <p class="d-inline" style="white-space: pre-wrap;">
                {{ generateResponseText(response) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <h5 v-if="questionResponses.length > 0" class="mt-4">
        <strong>Question Responses</strong>
      </h5>
      <div
        v-if="questionResponses.length > 0"
        style="background-color:gray; height:1px; width:100%"
      />
      <div
        class="container"
        v-for="response in questionResponses"
        :key="response.Grant_Application_Response_Id"
      >
        <strong class="d-block mb-2 mt-4">{{
          response.Application_Template_Response
            .Application_Template_Response_Category.Category
        }}</strong>
        <div class="container">
          <div class="row">
            <div class="col">
              <p class="d-inline" style="white-space: pre-wrap;">
                {{ generateResponseText(response) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <h5 v-if="measurableOutcomes.length > 0" class="mt-4">
        <strong>Measurable Outcomes</strong>
      </h5>
      <div
        v-if="measurableOutcomes.length > 0"
        style="background-color:gray; height:1px; width:100%"
      />
      <div
        class="container"
        v-for="response in measurableOutcomes"
        :key="response.Grant_Application_Response_Id"
      >
        <strong class="d-block mb-2 mt-4">{{
          response.Application_Template_Response
            .Application_Template_Response_Category.Category
        }}</strong>
        <div class="container">
          <div class="row">
            <div class="col">
              <p class="d-inline" style="white-space: pre-wrap;">
                {{ generateResponseText(response) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <h5 v-if="budget" class="mt-4">
        <strong>Budget</strong>
      </h5>
      <div
        v-if="budget"
        style="background-color:gray; height:1px; width:100%"
      />
      <div v-if="budget" class="container">
        <p class="mt-4">
          <strong>{{ budget.Title }}</strong>
        </p>
        <p>{{ budget.Subtitle }}</p>
        <table class="table">
          <tbody id="budgetTable">
            <tr
              v-for="(row, rowindex) in budgetRows"
              :key="rowindex"
              v-bind:class="{ 'header-row': row.h == true }"
            >
              <td
                v-for="(col, index) in row.c"
                :key="index"
                v-bind:colspan="col.cs ? col.cs : 1"
              >
                <div v-if="col.i == 'd'" class="mb-0">
                  <p>${{ col.v }}</p>
                </div>
                <div v-else>
                  <p v-if="col.sum" class="mb-0">
                    {{
                      $updateBudgetCol(
                        col,
                        row.c[index - 2].v * row.c[index - 1].v
                      )
                    }}
                  </p>
                  <p v-else-if="col.st" class="mb-0">
                    {{
                      $updateBudgetCol(
                        col,
                        $getBudgetSectionTotal(budgetRows, row.c[0].v)
                      )
                    }}
                  </p>
                  <p class="mb-0" v-else>
                    {{ col.v }}
                  </p>
                </div>
              </td>
            </tr>
            <tr v-if="budgetRows.length > 0" class="header-row">
              <td v-bind:colspan="budgetRows[0].c.length - 1">Total</td>
              <td>{{ $getBudgetTotal(budgetRows) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h5 v-if="lettersOfSupport.length > 0" class="mt-4">
        <strong>Letters of Support</strong>
      </h5>
      <div
        v-if="lettersOfSupport.length > 0"
        style="background-color:gray; height:1px; width:100%"
      />
      <div
        class="container"
        v-for="response in lettersOfSupport"
        :key="response.Grant_Application_Response_Id"
      >
        <div class="container">
          <div class="row mt-2">
            <div class="col">
              <p class="d-inline" style="white-space: pre-wrap;">
                {{ generateResponseText(response) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ShadingType,
  WidthType,
  TableCell,
  TableRow,
  Table,
  AlignmentType,
  Document,
  Paragraph,
  Packer,
  TextRun
} from "docx";
import { saveAs } from "file-saver";

export default {
  name: "ReviewApplication",
  components: {},
  props: {
    GrantApplication: Object,
    Budget: Object
  },
  data() {
    return {
      grantApplication: this.GrantApplication,
      questionResponses: this.GrantApplication.Grant_Application_Responses.filter(
        r =>
          r.Application_Template_Response.Application_Template_Response_Category
            .Application_Template_Response_Type == 2
      ),
      measurableOutcomes: this.GrantApplication.Grant_Application_Responses.filter(
        r =>
          r.Application_Template_Response.Application_Template_Response_Category
            .Application_Template_Response_Type == 1
      ),
      lettersOfSupport: this.GrantApplication.Grant_Application_Responses.filter(
        r =>
          r.Application_Template_Response.Application_Template_Response_Category
            .Application_Template_Response_Type == 8
      ),
      lettersOfInquiry: this.GrantApplication.Grant_Application_Responses.filter(
        r =>
          r.Application_Template_Response.Application_Template_Response_Category
            .Application_Template_Response_Type == 32
      ),
      budgetRows: this.GrantApplication.Grant_Application_Budget
        ? JSON.parse(this.GrantApplication.Grant_Application_Budget.Budget)
        : null,
      budget: this.GrantApplication.Grant_Application_Budget
    };
  },
  watch: {
    GrantApplication: function() {
      this.grantApplication = this.GrantApplication;
    },
    Budget: function() {
      (this.budgetRows = this.Budget ? JSON.parse(this.Budget.Budget) : null),
        (this.budget = this.Budget);
    }
  },
  created() {},
  async mounted() {
    //$(document).ready(function() {
    //  $('[data-toggle="popover"]').popover();
    //});
  },
  methods: {
    generateResponseText(response) {
      var blankNumbers = response.Application_Template_Response.Response.match(
        /[@]blank-\d+[@](?:hint:[^@]*[@])?/g
      );
      var splitText = response.Application_Template_Response.Response.split(
        /[@]blank-\d+[@](?:hint:[^@]*[@])?/g
      );
      var fullText = "";
      for (var i = 0; i < splitText.length - 1; i++) {
        fullText += splitText[i];
        fullText += this.getResponseAnswer(
          response.Grant_Application_Response_Answers,
          blankNumbers[i].match(/\d+/)[0]
        );
      }
      fullText += splitText[splitText.length - 1];
      return fullText;
    },
    generateDownloadResponseText(response) {
      var blankNumbers = response.Application_Template_Response.Response.match(
        /[@]blank-\d+[@]/g
      );
      var splitText = response.Application_Template_Response.Response.split(
        /[@]blank-\d+[@]/g
      );
      var fullText = "";
      for (var i = 0; i < splitText.length - 1; i++) {
        fullText += splitText[i];
        fullText += this.getResponseAnswer(
          response.Grant_Application_Response_Answers,
          blankNumbers[i].match(/\d+/)[0]
        );
      }
      fullText += splitText[splitText.length - 1];
      return fullText;
    },
    getResponseAnswer(responseAnswers, blankNumber) {
      var blankAnswer =
        responseAnswers.length > 0
          ? responseAnswers.find(
              a => a.Template_Response_Blank_Answer.Blank_Number == blankNumber
            )
          : null;
      var answer = blankAnswer
        ? blankAnswer.Template_Response_Blank_Answer
        : null;
      var answerText = answer ? answer.Answer : `___________`;
      return answerText.trim();
    },
    downloadApplication() {
      var docStyles = this.getDocStyles();
      var doc = new Document({
        styles: docStyles
      });
      var lettersOfInquiryParagraphs = this.getParagraphs(
        "Letters of Inquiry",
        this.lettersOfInquiry
      );
      var questionResponseParagraphs = this.getParagraphs(
        "Question Responses",
        this.questionResponses
      );
      var measurableOutcomesParagraphs = this.getParagraphs(
        "Measurable Outcomes",
        this.measurableOutcomes
      );
      var lettersOfSupportParagraphs = this.getParagraphs(
        "Letters of Support",
        this.lettersOfSupport
      );
      var budgetTableRows = this.getBudgetTableRows(
        this.budget,
        this.budgetRows
      );

      var firstSectionParagraphs = [
        new Paragraph({
          text: `Grant Application for ` + this.grantApplication.Grant.Title,
          style: "title",
          alignment: AlignmentType.CENTER
        })
      ];
      lettersOfInquiryParagraphs.forEach(paragraph => {
        firstSectionParagraphs.push(paragraph);
      });
      questionResponseParagraphs.forEach(paragraph => {
        firstSectionParagraphs.push(paragraph);
      });
      measurableOutcomesParagraphs.forEach(paragraph => {
        firstSectionParagraphs.push(paragraph);
      });
      budgetTableRows.forEach(row => {
        firstSectionParagraphs.push(row);
      });
      lettersOfSupportParagraphs.forEach(paragraph => {
        firstSectionParagraphs.push(paragraph);
      });

      doc.addSection({
        children: firstSectionParagraphs
      });

      Packer.toBlob(doc).then(blob => {
        saveAs(
          blob,
          "Grant Application - " + this.grantApplication.Grant.Title + ".docx"
        );
      });
    },
    getBudgetTableRows(budget, budgetRows) {
      var budgetTableRows = [
        new Paragraph({
          text: "Budget",
          style: "heading",
          alignment: AlignmentType.CENTER
        }),
        new Paragraph({ text: budget.Title, style: "heading" }),
        new Paragraph({ text: budget.Subtitle, style: "subHeading" })
      ];
      var tableRows = [];
      budgetRows.forEach(row => {
        var index = 0;
        var cells = [];
        row.c.forEach(cell => {
          var columnSpan = cell.cs ? cell.cs : 1;
          var shading = row.h
            ? { color: "#CCCCCC", val: ShadingType.SOLID }
            : {};
          var margin = { left: 50 };
          var children = null;
          if (cell.i == "d") {
            children = [
              new Paragraph({
                text: "$" + cell.v,
                style: row.h ? "subHeading" : "text"
              })
            ];
          } else {
            if (cell.sum) {
              children = [
                new Paragraph({
                  text: this.$updateBudgetCol(
                    cell,
                    row.c[index - 2].v * row.c[index - 1].v
                  ),
                  style: row.h ? "subHeading" : "text"
                })
              ];
            } else if (cell.st) {
              children = [
                new Paragraph({
                  text: this.$updateBudgetCol(
                    cell,
                    this.$getBudgetSectionTotal(budgetRows, row.c[0].v)
                  ),
                  style: row.h ? "subHeading" : "text"
                })
              ];
            } else {
              children = [
                new Paragraph({
                  text: cell.v,
                  style: row.h ? "subHeading" : "text"
                })
              ];
            }
          }
          cells.push(
            new TableCell({
              columnSpan: columnSpan,
              shading: shading,
              children: children,
              margins: margin
            })
          );
          index++;
        });

        if (row.h) {
          tableRows.push(new TableRow({ tableHeader: true, children: cells }));
        } else {
          tableRows.push(new TableRow({ children: cells }));
        }
      });

      tableRows.push(
        new TableRow({
          children: [
            new TableCell({
              columnSpan: budgetRows[0].c.length - 1,
              shading: { color: "#CCCCCC", val: ShadingType.SOLID },
              margins: { left: 50 },
              children: [new Paragraph({ text: "Total", style: "subHeading" })]
            }),
            new TableCell({
              shading: { color: "#CCCCCC", val: ShadingType.SOLID },
              margins: { left: 50 },
              children: [
                new Paragraph({
                  text: this.$getBudgetTotal(budgetRows),
                  style: "subHeading"
                })
              ]
            })
          ]
        })
      );

      budgetTableRows.push(
        new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE
          },
          rows: tableRows
        })
      );
      return budgetTableRows;
    },
    getParagraphs(heading, responses) {
      var paragraphs = [];
      if (responses.length > 0) {
        paragraphs.push(
          new Paragraph({
            text: heading,
            style: "heading",
            alignment: AlignmentType.CENTER
          })
        );

        responses.forEach(response => {
          if (
            heading != "Letters of Support" &&
            heading != "Letters of Inquiry"
          ) {
            paragraphs.push(
              new Paragraph({
                text:
                  response.Application_Template_Response
                    .Application_Template_Response_Category.Category,
                style: "subHeading"
              })
            );
          }
          var responseText = this.generateDownloadResponseText(response);
          responseText.split(/\r?\n/).forEach(responseChunk => {
            var hints = responseChunk.match(/_+hint:([^@]*)[@]/g);
            var splitText = responseChunk.split(/_*hint:[^@]*[@]/g);
            var children = [];
            for (var i = 0; i < splitText.length - 1; i++) {
              children.push(new TextRun({ text: splitText[i] }));
              if (hints != null && hints[i] != null) {
                children.push(
                  new TextRun({
                    text: hints[i].match(/_*hint:([^@]*)[@]/)[1],
                    italics: true,
                    color: 999900
                  })
                );
              }
            }
            children.push(
              new TextRun({ text: splitText[splitText.length - 1] })
            );
            paragraphs.push(
              new Paragraph({ children: children, style: "text" })
            );
          });
        });
      }
      return paragraphs;
    },
    getDocStyles() {
      return {
        paragraphStyles: [
          {
            id: "title",
            name: "Title",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 32,
              bold: true
            },
            paragraph: {
              spacing: {
                line: 276
              }
            }
          },
          {
            id: "heading",
            name: "Heading",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 28,
              bold: true
            },
            paragraph: {
              spacing: {
                before: 240,
                after: 120
              }
            }
          },
          {
            id: "subHeading",
            name: "SubHeading",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 24,
              bold: true
            },
            paragraph: {
              spacing: {
                before: 120,
                after: 120
              }
            }
          },
          {
            id: "tableHeading",
            name: "Table Heading",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 24,
              bold: true
            }
          },
          {
            id: "text",
            name: "Text",
            basedOn: "Normal",
            next: "Normal",
            quickFormat: true,
            run: {
              size: 24
            },
            paragraph: {
              keepLines: true
            }
          }
        ]
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
